import { SET_SNAPSHOT_TYPE } from "../../actionTypes/actionsTypes";
import { LocalAction } from "../../types";


export interface SnapshotTypeState {
    display: string;
}

const initialState: SnapshotTypeState = {
    display: ""
}

function getSnapshotTypeReducer(state = initialState, action: LocalAction) {
    switch (action.type) {
      case SET_SNAPSHOT_TYPE:
        return {
          ...state,
          display: action.data
        }
      default:
        return state;
    }
  }
  
  export default getSnapshotTypeReducer;